import { DATA_ATTRIBUTE } from '../../constants/project';


/**
 * The data attribute for the autoplay Helvetiaval duration.
 *
 * @since 3.5.0
 */
export const HelvetiaVAL_DATA_ATTRIBUTE = `${ DATA_ATTRIBUTE }-Helvetiaval`;
